import { CircleCheck, CircleAlert, CircleSlash } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Compact confidence meter used during AI ingestion review.
 * - >= 0.85 → green check
 * - 0.6 — 0.85 → amber
 * - < 0.6 → rose (requires review)
 */
export const ConfidenceMeter = ({ value, size = 'sm', label, className }) => {
  const v = Number(value) || 0;
  const pct = Math.round(v * 100);
  const tone = v >= 0.85 ? 'emerald' : v >= 0.6 ? 'amber' : 'rose';
  const Icon = tone === 'emerald' ? CircleCheck : tone === 'amber' ? CircleAlert : CircleSlash;
  const cls = {
    emerald: 'text-emerald-600 bg-emerald-500/10 border-emerald-500/30',
    amber: 'text-amber-600 bg-amber-500/10 border-amber-500/30',
    rose: 'text-rose-600 bg-rose-500/10 border-rose-500/30',
  }[tone];
  const iconSize = size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-mono-num',
        cls,
        className,
      )}
      data-testid="confidence-meter"
      title={`AI confidence ${pct}% — ${tone === 'rose' ? 'review required' : tone === 'amber' ? 'verify before publish' : 'high confidence'}`}
    >
      <Icon className={iconSize} />
      {label ? `${label} · ${pct}%` : `${pct}%`}
    </span>
  );
};

export const requiresReview = (value) => (Number(value) || 0) < 0.6;
